export const scrollRevealViewport = {
  once: true,
  margin: "140px 0px",
} as const;

export const inViewScrollRootMargin = "140px 0px";

export const intersectionObserverScrollReveal: IntersectionObserverInit = {
  threshold: 0,
  rootMargin: "140px 0px",
};

export function parseRootMarginToPixels(m: string): {
  top: number;
  right: number;
  bottom: number;
  left: number;
} {
  const parts = m.trim().split(/\s+/).filter(Boolean);
  const nums = parts.map((p) => {
    const n = parseFloat(p);
    return Number.isFinite(n) ? n : 0;
  });
  if (nums.length === 0) {
    return { top: 0, right: 0, bottom: 0, left: 0 };
  }
  if (nums.length === 1) {
    const v = nums[0];
    return { top: v, right: v, bottom: v, left: v };
  }
  if (nums.length === 2) {
    const [vertical, horizontal] = nums;
    return { top: vertical, bottom: vertical, left: horizontal, right: horizontal };
  }
  if (nums.length === 3) {
    const [t, h, b] = nums;
    return { top: t, right: h, bottom: b, left: h };
  }
  const [top, right, bottom, left] = nums;
  return { top, right, bottom, left };
}

export function elementIntersectsExpandedRoot(
  el: Element,
  rootMargin: string = scrollRevealViewport.margin
): boolean {
  if (typeof window === "undefined") return false;
  const { top: mt, right: mr, bottom: mb, left: ml } = parseRootMarginToPixels(rootMargin);
  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const leftEdge = -ml;
  const topEdge = -mt;
  const rightEdge = vw + mr;
  const bottomEdge = vh + mb;
  return (
    rect.left < rightEdge && rect.right > leftEdge && rect.top < bottomEdge && rect.bottom > topEdge
  );
}
